import { axiosInstance } from 'api/instance';
import { Account } from 'api/Account/types';
import PaginatedData from 'common/types/PaginatedData';

import { AxiosResponse } from 'axios';

export const getAccountsRequest = (
  page: string,
  pageSize: string,
  search: string,
  abortController: AbortController,
): Promise<AxiosResponse<PaginatedData<Account>>> => {
  return axiosInstance.get<PaginatedData<Account>>(`account?page=${page}&pageSize=${pageSize}&filter=${search}`, { signal: abortController.signal });
};

export const createAccountRequest = (account: Account): Promise<AxiosResponse<Account>> => {
  const { name, accountId } = account;
  return axiosInstance.post('account', { name, accountId });
};

export const changeAccountRequest = (account: Account): Promise<AxiosResponse<Account>> => {
  const { id, name, accountId } = account;
  return axiosInstance.put(`account/${id}`, { name, accountId });
};

export const deleteAccountRequest = (accountId: string): Promise<AxiosResponse> => {
  return axiosInstance.delete(`account/${accountId}`);
};
